import { render, staticRenderFns } from "./DealsPage.vue?vue&type=template&id=02d741c8&scoped=true"
import script from "./DealsPage.vue?vue&type=script&lang=js"
export * from "./DealsPage.vue?vue&type=script&lang=js"
import style0 from "./DealsPage.vue?vue&type=style&index=0&id=02d741c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d741c8",
  null
  
)

export default component.exports